import React, {useState, useEffect} from "react";
import {instance} from "../../config/axios-cnf";
import SelectField from "../SelectField";
import {useDispatch} from "react-redux";
import {SUBJECTS_FETCH_SUCCESS} from "../../reducers/subjects";


const SubjectField = (props) => {

    let [subject, setSubject] = useState([]);
    let [loading, setLoading] = useState(true);
    let [isDisabled, setIsDisabled] = useState(false);
    let dispatch = useDispatch()


    useEffect(() => apiGetSubject(props?.filters, (data) => {
        let array = [];
        data.map(item => {
            array.push({
                label: item.name,
                value: item.id
            });
        })

        dispatch({type: SUBJECTS_FETCH_SUCCESS, payload: array})

        setSubject(array);
        setLoading(false)

        if(array.length === 1){
            props.onSingleItem(data[0])
        }

    }, err => {
        //Toast.warn(translate("loading_error"))
    }), [])


    if(subject.length === 1){
        return (
            <div>
                <h2 className={"text-base font-bold"}>Subjekt: {subject[0].label}</h2>
            </div>
        )
    }

    return (
        <SelectField {...props}
                     disabled={loading || props.disabled}
                     options={subject}
                     isMandatory={!!props.validate}
                     isMulti={props.isMulti}
        />
    )


}

export const apiGetSubject = (filters, callback, error) => {
    if(filters?.systemSubject) {
        instance.get('/api/v2/subjects')
            .then(response => callback(response.data))
    }else{
        instance.get('/api/v2/user/subject', {params: filters})
            .then(response => callback(response.data))
    }
}

export default SubjectField
